import React from 'react';
import { observer } from 'mobx-react';
import { WeaSelectGroup } from 'ecCom';

@observer
export default class SelectGroupNew extends React.Component<any, any>{

    onChange = (v) => {
        const {onChange,fieldid, isChild} = this.props;
        onChange(fieldid,v,isChild);
    }

    render() {
        return <WeaSelectGroup 
            {...this.props}
            onChange={this.onChange}
        ></WeaSelectGroup>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/commonComs/SelectGroupNew.tsx